<section class="page">
  <header class="page-header">
    <h2>Voir les composants</h2>
    <button type="button" (click)="refresh()">Rafraîchir</button>
  </header>

  <div class="toolbar">
    <label for="filter">Filtre</label>
    <input
      id="filter"
      type="text"
      [(ngModel)]="filter"
      (ngModelChange)="onFilterChange()"
      placeholder="Nom, fabricant, standard emballage, commentaire"
    />

    <label for="classe-filter">Classe</label>
    <select id="classe-filter" [(ngModel)]="classeFilter" (ngModelChange)="onClasseFilterChange()">
      <option value="">Toutes les classes</option>
      @for (classe of classesComposants; track classe.id) {
        <option [value]="classe.nom">{{ classe.nom }}</option>
      }
    </select>
  </div>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (loading) {
    <p>Chargement...</p>
  } @else if (error) {
    <p class="error">{{ error }}</p>
  } @else {
    <p class="meta">{{ filteredComposants.length }} résultat(s)</p>

    @if (filteredComposants.length === 0) {
      <p>Aucun composant trouvé pour ce filtre.</p>
    }

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Image</th>
            <th>Nom</th>
            <th>Prix hors taxe et hors frais de livraison</th>
            <th>Standard emballage</th>
            <th>Unité</th>
            <th>Classe</th>
            <th>Fabricant</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (composant of pagedComposants; track composant.id) {
            <tr>
              <td>
                @if (composant.photo) {
                  <img
                    class="thumb"
                    [src]="photoUrl(composant.photo)"
                    [alt]="composant.nom"
                    (click)="openImageModal(composant.photo, composant.nom)"
                  />
                } @else {
                  <span class="no-image">-</span>
                }
              </td>
              <td>{{ composant.nom }}</td>
              <td>{{ composant.prix ?? '-' }}</td>
              <td>{{ composant.standard_emballage ?? '-' }}</td>
              <td>{{ composant.unite ?? '-' }}</td>
              <td>{{ composant.classe_nom ?? '-' }}</td>
              <td>{{ composant.ref_fabricant ?? '-' }}</td>
              <td class="actions-cell">
                <button
                  type="button"
                  class="edit"
                  (click)="editComposant(composant)"
                >
                  Editer
                </button>
                <button
                  type="button"
                  class="danger"
                  [disabled]="deletingId === composant.id"
                  (click)="deleteComposant(composant)"
                >
                  {{ deletingId === composant.id ? 'Suppression...' : 'Supprimer' }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button type="button" (click)="prevPage()" [disabled]="page <= 1">Précédent</button>
      <span>Page {{ page }} / {{ totalPages }}</span>
      <button type="button" (click)="nextPage()" [disabled]="page >= totalPages">Suivant</button>
    </div>
  }

  @if (imageModalUrl) {
    <div class="image-modal-overlay" (click)="closeImageModal()">
      <div class="image-modal-content" (click)="$event.stopPropagation()">
        <button type="button" class="image-modal-close" (click)="closeImageModal()" aria-label="Fermer">×</button>
        <img [src]="imageModalUrl" [alt]="imageModalAlt" />
      </div>
    </div>
  }
</section>
